import { createContext, useReducer } from 'react';
import reducer from './reducer';
import { CapinetInitialState } from './initialize';
import Cabinet from '../index';
import PtopTypes from 'prop-types';
export const CabinetContext = createContext({});
export const CabinetProvider = ({ permissions }) => {
  const [state, dispatch] = useReducer(reducer, CapinetInitialState);
  return (
    <CabinetContext.Provider value={{ state, dispatch, permissions }}>
      <Cabinet />
    </CabinetContext.Provider>
  );
};
CabinetProvider.propTypes = {
  permissions: PtopTypes.array
};
